import React from 'react';
import { useActiveEntity, useMenus } from "@shapeable/ui"
import { Menu, MenuItem } from '@shapeable/types';
import { MenuItemsProvider } from '../../components/context/menu-items-context';

export const MenusNavigationProvider: React.FC<any> = ({ children }) => {

  // const { items } = useLinearMenu() as { items: Menu[] } || { items: [] } as { items: Menu[] };

  const menus = useMenus();
  const currentPage = useActiveEntity();

  const currentMenu = menus?.find((menuItem: Menu) =>
    menuItem.items.some((item: MenuItem) =>
      (currentPage.__path && item?.path === currentPage.__path) ||
      (currentPage.id && item?.page?.id === currentPage.id) ||
      (currentPage.slug && item?.slug === currentPage.slug)
    )
  ) || null;

  const value = {
    items: currentMenu?.items || [],
    name: currentMenu?.name || undefined,
  };

  return (
    <MenuItemsProvider value={value}>
      {children}
    </MenuItemsProvider>
  );
}